import { createSlice } from 'redux-starter-kit';

const createState = (state, action) => {
  if (!action) return state;
  return { ...state, ...action.payload };
};

const CircleNew = createSlice({
  slice: 'circle_new',
  initialState: {
    servicesCategories: [],
    countriesPrefs: [],
    pageNum: '0',
    circleId: 0,
    genreKeyword: '',
    selectedGenres: [],
    circle: {
      id: 0,
      name: '',
      about: '',
      pref: '',
      pref_id: '',
      request: '',
      web_url: '',
      membership_fees: '',
      place: '',
      private_status: false,
      is_request_required: false,
      activity_frequency: '',
      main_image_url: '',
      recruit_status: 1,
      categories: [],
      circles_self_introduction_template: {
        description: '',
      },
      is_talkroom_on: true,
      parentCircleId: null,
    },
    checkDisabled: false,
    unChecked: '',
    isValidated: false,
  },
  reducers: {
    initialSet: createState,
    initialEditSet: createState,
    set: createState,
    createNewCircle: createState,
    changePage: createState,
    changeGenreKeyword: createState,
    changeSelectedGenre: createState,
    createCategory: createState,
    createOshikatsuGenre: createState,
    changeRecruitAge: createState,
    uploadCircleImage: createState,
    uploadCircleImageSuccess: createState,
    uploadCircleImageFailure: createState,
    changeFields: createState,
    createSuccess: createState,
    createFailure: createState,
    createCategorySuccess: createState,
    createCategoryFailure: createState,
    getOshikatsuData: createState,
    getOshikatsuDataSuccess: createState,
    getOshikatsuDataFailure: createState,
    createOshikatsuGenreSuccess: createState,
    createOshikatsuGenreFailure: createState,
    submitSuccess: createState,
    submitError: createState,
    updateCircle: createState,
    updateCircleTag: createState,
    createCircle: createState,
    validation: createState,
    createRelation: createState,
    createRelationSuccess: createState,
    createRelationFailure: createState,
  },
});

export default CircleNew;
